import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiDevice } from "../_types/devices.types";

type DevicesMeta = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

type DevicesQueryParams = {
  page: number;
  limit: number;
  deviceType?: string;
  deviceStatus?: string;
  enrollment?: string;
  q?: string;
  /** API: `1` = active only (default). `all` includes soft-deleted (`is_active = 0`). */
  isActive?: "all" | "0" | "1";
};

export const useDevicesQuery = (params: DevicesQueryParams) => {
  const apiParams = {
    page: params.page,
    limit: params.limit,
    deviceType: params.deviceType ?? "all",
    deviceStatus: params.deviceStatus ?? "all",
    enrollment: params.enrollment ?? "all",
    isActive: params.isActive ?? "1",
    q: params.q,
  };

  return useQuery({
    queryKey: ["devices", apiParams],
    queryFn: async () => {
      const response = await axiosInstance.get<
        ApiResponse<ApiDevice[], DevicesMeta>
      >("/v2/devices", {
        params: apiParams,
      });
      const items = response.data.data ?? [];
      const meta = response.data.meta ?? {
        total: items.length,
        page: params.page,
        limit: params.limit,
        totalPages: 1,
      };
      return { items, meta };
    },
    refetchInterval: 25_000,
  });
};
